import React from "react";
import { Layout, Typography, Button, Image, Grid } from "antd";
import { ArrowLeftOutlined, GlobalOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png"; // Adjust path as needed
import { sanecka } from "../assets/assets";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../actions/LanguageActions";

const { Header } = Layout;
const { Title } = Typography;
const { useBreakpoint } = Grid;

const ArtistNavigation = ({ artistName, setSeeAll }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { translations, language } = useSelector((state) => state.language);

  const screens = useBreakpoint();
  const level = screens.xs ? 5 : 3; // Level 5 for small screens, Level 4 for large
  const padding = screens.xs ? "0px 10px" : "0px 20px"; // Level 5 for small screens, Level 4 for large



  const handleLanguageChange = () => {
    dispatch(setLanguage(language === "en" ? "sw" : "en"));

  };

  return (
    <Header
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#fff",
        padding: padding,
        // boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {/* Back Button */}
          <Button
            type="text"
            icon={<ArrowLeftOutlined style={{ fontSize: 20, color: "#333" }} />}
            onClick={() => {
              setSeeAll(false);

              if (window.history.length > 1) {
                navigate(-1);
              } else {
                navigate("/");
              }
            }}
            style={{ marginRight: 20 }}
          />
          {/* Logo */}
          {/* <Image src={sanecka} alt="Logo" width={60} height={60} style={{verticalAlign:'top'}} preview={false} /> */}

          {/* Artist Name */}
          <Title level={level} style={{ margin: 0, marginLeft: 15, color: "#333" }}>
          {translations.artist.title}
          </Title>

        </div>
        <Button
          type="text"
          icon={<GlobalOutlined style={{ fontSize: 20, color: "#333", alignSelf: 'center' }} />}
          onClick={handleLanguageChange}
        >
          {language?.charAt(0).toUpperCase() + language?.slice(1)}
        </Button>
      </div>


    </Header>
  );
};

export default ArtistNavigation;
